import { render, staticRenderFns } from "./MotorInfo.vue?vue&type=template&id=2bf424c0&scoped=true&"
import script from "./MotorInfo.vue?vue&type=script&lang=js&"
export * from "./MotorInfo.vue?vue&type=script&lang=js&"
import style0 from "./MotorInfo.vue?vue&type=style&index=0&id=2bf424c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf424c0",
  null
  
)

export default component.exports